import { createContext, useReducer } from "react";

export const AnalysisContext = createContext();

export const analysisReducer = (state, action) => {
    switch (action.type) {
        case 'SET_ANALYSIS':
            return {
                analysis: action.payload
            }
        case 'CREATE_ANALYSIS':
            return {
                analysis: [action.payload, ...state.analysis]
            }
        case 'DELETE_ANALYSIS':
            return {
                analysis: state.analysis.filter(a => a._id !== action.payload._id)
            }
        default:
            return state
    };
};

export const AnalysisContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(analysisReducer, {
        analysis: null
    });

    return (
        <AnalysisContext.Provider value={{ ...state, dispatch }}>
            {children}
        </AnalysisContext.Provider>
    );
};